import { useLocation } from "@remix-run/react";
import clsx from "clsx";
import { motion } from "framer-motion";
import { ReactNode } from "react";
import { useNavShowing } from "~/contexts/NavShowingProvider";
import { PAGE_TRANSITION_DELAY } from "~/contexts/PageTransitionProvider";
import { getBlackPage } from "../utils/getBlackPage";

export default function NavWrapper({
  isContentfulNav,
  children,
  open,
  className,
  id,
}: {
  isContentfulNav?: boolean;
  id: string;
  children: ReactNode;
  open?: boolean;
  className?: string;
}) {
  const { navShowing, atTopOfPage } = useNavShowing();
  const { pathname } = useLocation();
  const blackPage = isContentfulNav ? true : getBlackPage(pathname);

  return (
    <nav
      id={id}
      className={clsx(
        "nav_header transition-[top, background-color, text] ease-in-out fixed left-0 right-0 z-[1000] h-mobile-nav w-full duration-500 lg:h-desktop-nav",
        className,
        {
          "lg:top-[-147px]": !navShowing,
          // Keep mobile nav always visible - remove the hide behaviour
          "lgmax:top-[50px]": atTopOfPage,
          "lgmax:top-0": !atTopOfPage,
          "lg:top-[50px]": navShowing && atTopOfPage,
          "lg:top-0": navShowing && !atTopOfPage,
          "lgmax:bg-white": !atTopOfPage && !open && !blackPage,
          "lgmax:bg-black": open || (blackPage && !atTopOfPage),
          "lgmax:bg-transparent": !open && atTopOfPage && !isContentfulNav, // only for non contentful nav
          "lgmax:text-black": !blackPage && !open,
          "lgmax:text-white": blackPage || open,
          "bg-black": isContentfulNav,
        },
      )}
    >
      <div className="lgmax:tbi-grid h-full w-full">
        <motion.div
          initial={{ position: "relative", top: "-130%" }}
          animate={{
            top: 0,
            transition: {
              duration: 1,
              delay: PAGE_TRANSITION_DELAY / 1000,
            },
            transitionEnd: {
              position: "static",
            },
          }}
          className="col-span-full lgmax:flex"
        >
          {children}
        </motion.div>
      </div>
    </nav>
  );
}
